export enum PentestScanColumn {
  Severity = 'severity',
  Name = 'name',
  Type = 'type',
  NodeZeroIp = 'nodeZeroIp',
  ImpactsCount = 'impactsCount',
  WeaknessesCount = 'weaknessesCount',
  CredentialsCount = 'credentialsCount',
  HostsCount = 'hostsCount',
  CreatedAt = 'createdAt',
  CompletedAt = 'completedAt',
  Duration = 'duration',
  Status = 'status',
  Actions = 'actions',
  Expand = 'expand',
}

export namespace PentestScanColumn {
  export const allColumns: string[] = [
    PentestScanColumn.Severity,
    PentestScanColumn.Name,
    PentestScanColumn.Type,
    PentestScanColumn.ImpactsCount,
    PentestScanColumn.WeaknessesCount,
    PentestScanColumn.CredentialsCount,
    PentestScanColumn.HostsCount,
    PentestScanColumn.CreatedAt,
    PentestScanColumn.CompletedAt,
    PentestScanColumn.Duration,
    PentestScanColumn.Status,
    PentestScanColumn.Actions,
  ];

  export const displayedColumns: string[] = [
    PentestScanColumn.Severity,
    PentestScanColumn.Name,
    PentestScanColumn.Type,
    PentestScanColumn.ImpactsCount,
    PentestScanColumn.WeaknessesCount,
    PentestScanColumn.CredentialsCount,
    PentestScanColumn.HostsCount,
    PentestScanColumn.CreatedAt,
    PentestScanColumn.CompletedAt,
    PentestScanColumn.Duration,
    PentestScanColumn.Status,
    PentestScanColumn.Actions,
  ];

  export const translateKey = (column: string) => {
    switch (column) {
      case PentestScanColumn.Name:
        return 'dashboard.pentestTable.columns.name.label';
      case PentestScanColumn.Type:
        return 'dashboard.pentestTable.columns.type.label';
      case PentestScanColumn.Status:
        return 'dashboard.pentestTable.columns.status.label';
      case PentestScanColumn.NodeZeroIp:
        return 'dashboard.pentestTable.columns.nodeZeroIp.label';
      case PentestScanColumn.Severity:
        return 'dashboard.pentestTable.columns.severity.label';
      case PentestScanColumn.ImpactsCount:
        return 'dashboard.pentestTable.columns.impacts.label';
      case PentestScanColumn.WeaknessesCount:
        return 'dashboard.pentestTable.columns.weaknesses.label';
      case PentestScanColumn.CredentialsCount:
        return 'dashboard.pentestTable.columns.credentials.label';
      case PentestScanColumn.HostsCount:
        return 'dashboard.pentestTable.columns.hosts.label';
      case PentestScanColumn.CreatedAt:
        return 'dashboard.pentestTable.columns.created.label';
      case PentestScanColumn.CompletedAt:
        return 'dashboard.pentestTable.columns.completed.label';
      case PentestScanColumn.Duration:
        return 'dashboard.pentestTable.columns.duration.label';
      case PentestScanColumn.Actions:
        return 'dashboard.pentestTable.columns.actions.label';
      default:
        return '';
    }
  };

  export const translateAbbreviationKey = (column: string) => {
    switch (column) {
      case PentestScanColumn.Name:
        return 'dashboard.pentestTable.columns.name.abbreviation';
      case PentestScanColumn.Status:
        return 'dashboard.pentestTable.columns.status.abbreviation';
      case PentestScanColumn.NodeZeroIp:
        return 'dashboard.pentestTable.columns.nodeZeroIp.abbreviation';
      case PentestScanColumn.Severity:
        return 'dashboard.pentestTable.columns.severity.abbreviation';
      case PentestScanColumn.ImpactsCount:
        return 'dashboard.pentestTable.columns.impacts.abbreviation';
      case PentestScanColumn.WeaknessesCount:
        return 'dashboard.pentestTable.columns.weaknesses.abbreviation';
      case PentestScanColumn.CredentialsCount:
        return 'dashboard.pentestTable.columns.credentials.abbreviation';
      case PentestScanColumn.HostsCount:
        return 'dashboard.pentestTable.columns.hosts.abbreviation';
      case PentestScanColumn.CreatedAt:
        return 'dashboard.pentestTable.columns.created.abbreviation';
      case PentestScanColumn.CompletedAt:
        return 'dashboard.pentestTable.columns.completed.abbreviation';
      case PentestScanColumn.Duration:
        return 'dashboard.pentestTable.columns.duration.abbreviation';
      default:
        return translateKey(column);
    }
  };

  export const tooltipTranslateKey = (column: string) => {
    switch (column) {
      case PentestScanColumn.ImpactsCount:
        return 'dashboard.pentestTable.columns.impacts.tooltip';
      case PentestScanColumn.WeaknessesCount:
        return 'dashboard.pentestTable.columns.weaknesses.tooltip';
      case PentestScanColumn.CredentialsCount:
        return 'dashboard.pentestTable.columns.credentials.tooltip';
      case PentestScanColumn.HostsCount:
        return 'dashboard.pentestTable.columns.hosts.tooltip';
      default:
        return '';
    }
  };

  export const sortField = (column: string) => {
    switch (column) {
      case PentestScanColumn.Name:
        return 'name';
      case PentestScanColumn.Status:
        return 'status';
      case PentestScanColumn.NodeZeroIp:
        return 'node_zero_ip';
      case PentestScanColumn.ImpactsCount:
        return 'impacts_count';
      case PentestScanColumn.WeaknessesCount:
        return 'weaknesses_count';
      case PentestScanColumn.CredentialsCount:
        return 'credentials_count';
      case PentestScanColumn.HostsCount:
        return 'hosts_count';
      case PentestScanColumn.CreatedAt:
        return 'created_at';
      case PentestScanColumn.CompletedAt:
        return 'completed_at';
      case PentestScanColumn.Duration:
        return 'duration';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
